// removed by extract-text-webpack-plugin
module.exports = {"templatePreviewContainer":"TemplateHeader__templatePreviewContainer___5O8hU","templatePreviewContainerVideoOnly":"TemplateHeader__templatePreviewContainerVideoOnly___3gUhI"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/css/TemplateHeader.less
// module id = 151
// module chunks = 0